export const Link04Icon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.74984 5.8335H6.33317C4.03198 5.8335 2.1665 7.69898 2.1665 10.0002C2.1665 12.3014 4.03198 14.1668 6.33317 14.1668H7.99984C10.301 14.1668 12.1665 12.3014 12.1665 10.0002M14.2498 14.1668H14.6665C16.9677 14.1668 18.8332 12.3014 18.8332 10.0002C18.8332 7.69898 16.9677 5.8335 14.6665 5.8335H12.9998C10.6987 5.8335 8.83317 7.69898 8.83317 10.0002"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
  </svg>
);
